<template>
  <div class="company-value">
    <AnimatedNumber class="company-value__actual" :decimals="1" :value="companyValue * 100" />

    <div class="company-value__average">
      <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
      ({{ $t('ui.symbol.average') }}
      <AnimatedNumber
        class="company-value__average-value"
        :decimals="1"
        :value="averageCompanyValue * 100"
      />)
      <!-- eslint-enable @intlify/vue-i18n/no-raw-text -->
    </div>
  </div>
</template>

<script>
import AnimatedNumber from '../AnimatedNumber';

export default {
  name: 'CompanyValue',

  components: {
    AnimatedNumber,
  },

  props: {
    companyValue: {
      type: Number,
      required: true,
    },

    averageCompanyValue: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.company-value {
  display: flex;
  align-items: center;
  justify-content: center;
}

.company-value__actual {
  @include font-rem(45px);
  font-weight: bold;
}

.company-value__average {
  margin-left: 20px;
  @include font-rem(28px);
}
</style>
